import React from 'react';
import Button from 'src/components/Button/Button';
import FontAwesomeIcon from 'src/components/Icon/FontAwesomeIcon';
import { PATHS } from 'src/common/constants';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import MobileAppCtaCard from '../MobileAppCtaCard/MobileAppCtaCard';
import './key-pickup-details.scss';

interface IKeyPickupDetailsProps {
  originalEvent: ICalendarEventData;
}

const KeyPickupDetails = ({ originalEvent }: IKeyPickupDetailsProps) => {
  const routeId: string = `${originalEvent.propertyId}&${originalEvent.suiteId}`;

  const keyPickupUrl: string = `${window.location.origin}${PATHS.KEY_PICKUP_VIEW.replace(
    ':id',
    routeId
  )}`;

  return (
    <>
      <div className="key-pickup-details">
        <h3>Complete this key pickup</h3>

        <p className="key-pickup-details-lead">
          If you like, you can complete this key pickup in the Juniper web app:
        </p>

        <div className="key-pickup-details-action">
          <a href={keyPickupUrl} target="_blank" rel="noopener noreferrer">
            <Button
              type="button"
              color="teal"
              size="small"
              label="Complete in web app"
              icon={
                <FontAwesomeIcon
                  glyph="external-link"
                  weight="light"
                  size="small"
                />
              }
            />
          </a>
        </div>
      </div>

      <MobileAppCtaCard
        header="Complete key pickups on mobile"
        description="Prefer your phone? Key pickups can also be completed on the go in the Juniper mobile app."
      />
    </>
  );
};

export default KeyPickupDetails;